import { ERegionCode } from '../../interfaces';

export type TRegionCoverageMap = {
  region: string;
  [index: string]: string | null;
};

export type TAgeConfig = {
  region: ERegionCode;
  age: number;
};

export const ANNUAL_MILEAGE_STATES = ['CA'];
export const ANTI_THEFT_DEVICE_STATES = ['CA', 'IL'];
export const AUTOMATIC_EMERGENCY_BRAKING_STATES = ['SC'];
export const BUSINESS_USE_STATES = ['SC'];
export const DEFENSIVE_DRIVER_STATES = ['SC'];
export const MATURE_DRIVER_STATES_CONFIG: TAgeConfig[] = [
  {
    region: 'CA',
    age: 50,
  },
  {
    region: 'IL',
    age: 55,
  },
  {
    region: 'OH',
    age: 60,
  },
  {
    region: 'TN',
    age: 55,
  },
];
export const RIDESHARE_USE_STATES = ['AZ', 'IL', 'MO', 'OH', 'SC', 'TN', 'TX'];
export const SELECT_PRIMARY_DRIVER_STATES = ['CA'];
export const STUDENT_DRIVER_STATES_CONFIG: TAgeConfig[] = [
  {
    region: 'CA',
    age: 25,
  },
];
export const VEHICLE_USE_STATES = ['CA'];
export const OCCUPATION_STATES = ['CA'];
export const HAS_DEGREE_OR_LICENSE_STATES = ['CA'];
export const EXCLUDE_PURCHASE_YEAR = ['CA'];

const IN_UMBI_UIMBI_COVERAGE_MAP: TRegionCoverageMap = {
  region: 'IN',
  '25000/50000': '50000/50000',
  '50000/50000': '25000/50000',
};

const CO_UMBI_UIMBI_COVERAGE_MAP: TRegionCoverageMap = {
  region: 'CO',
  '25000/50000': '50000/50000',
  '50000/50000': '25000/50000',
};

const GA_UMBI_UIMBI_COVERAGE_MAP: TRegionCoverageMap = {
  region: 'GA',
  '25000/50000': '50000/50000',
  '50000/50000': '25000/50000',
};

const OR_UMBI_UIMBI_COVERAGE_MAP: TRegionCoverageMap = {
  region: 'GA',
  '25000/50000': '50000/50000',
  '50000/50000': '25000/50000',
};

const MO_UMBI_UIMBI_COVERAGE_MAP: TRegionCoverageMap = {
  region: 'MO',
  '25000/50000': 'null',
  null: '25000/50000',
};

export const REGION_COVERAGE_RULES = {
  CDW_REQUIRES_UMBI_AND_COLL: ['CA'],
  PD_CANNOT_EXCEED_BI: ['CA'],
  UMBI_MATCHES_UIMBI: ['IL', 'MO'],
  UMBI_UIMBI_COVERAGE_MAP: [
    IN_UMBI_UIMBI_COVERAGE_MAP,
    MO_UMBI_UIMBI_COVERAGE_MAP,
    CO_UMBI_UIMBI_COVERAGE_MAP,
    GA_UMBI_UIMBI_COVERAGE_MAP,
    OR_UMBI_UIMBI_COVERAGE_MAP,
  ],
  UMPD_REQUIRES_UMBI: ['IN', 'OH', 'TN', 'TX'],
  SKIP_UMPD_SIDE_EFFECT: ['CA'],
  SKIP_UIMBI_SIDE_EFFECT: ['OH', 'CA'],
  VUMPD_REQUIRES_NO_COMP_COLL: ['OH'],
  COMP_COLL_REQUIRED_SEPARATELY: ['CA'],
  COLL_VUMPD_REQUIRE_MUTUAL_EXCLUSION: ['CA'],
};

export const REGION_QUOTE_SUMMARY_RULES = {
  SHOW_CARBON_OFFSET_COVERAGE: ['AZ', 'IL', 'IN', 'MO', 'OH', 'TN'],
};

export default {
  ANTI_THEFT_DEVICE_STATES,
  AUTOMATIC_EMERGENCY_BRAKING_STATES,
  BUSINESS_USE_STATES,
  DEFENSIVE_DRIVER_STATES,
  MATURE_DRIVER_STATES_CONFIG,
  REGION_COVERAGE_RULES,
  REGION_QUOTE_SUMMARY_RULES,
} as const;
